import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import CheckBox from '../../common/CheckBox'
import { TatContext } from './context/context'

const DtcRow = ({ dtcId }) => {
  const [state, dispatch] = useContext(TatContext)
  return (
    <div className="inline-block">
      <CheckBox
        name={`dtc_id[${dtcId}]`}
        value={dtcId}
        checked={state?.selected_dtc?.includes(dtcId)}
        onChange={() => {
          dispatch({ type: 'select_dtc', data: dtcId })
        }}
      />
    </div>
  )
}

DtcRow.propTypes = {
  dtcId: PropTypes.number.isRequired,
}

export default DtcRow
